import { Alert } from "@icg360/design-system";

import { ErrorBase } from "./ErrorBase";

export const Error500 = () => {
  return (
    <ErrorBase>
      <Alert
        appearance="danger"
        title="Failed to load quote."
        description="Something went wrong while
            loading your quote. Try reloading the page. If the problem
            continues, reach out to your insurance representative."
      />
    </ErrorBase>
  );
};
